import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Switch as MuiSwitch,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import SummaryTable from "../admin/SummaryTable"; // adjust path as needed

const ProductPreviewCard = ({
  item,
  mainImage,
  extraDisplay,
  isQualityVerified,
  onQualityChange,
  t,
  itemCounter,
  priceArray,
  showAdvanced,
  productTotal,
  productPriceAverage,
  productDiscountAverage,
  totalDisplayForCount,
  extraItemTotal,
  extraPriceAverage,
  extraDiscountAverage,
  delivery,
  bonusDiscountFunc,
  grandTotal,
}) => {
  const [showSummary, setShowSummary] = useState(false);

  return (
    <>
      <Paper
        elevation={0}
        className='p-6 my-8 flex flex-col md:flex-row gap-4 items-start border border-gray-200'>
        {/* Product Image */}
        <Box className='w-full md:w-1/3'>
          <img
            src={mainImage}
            alt={item?.title}
            className='rounded-md object-cover w-full h-64'
          />
        </Box>

        {/* Product Info */}
        <Box className='w-full md:w-2/3 space-y-3'>
          {/* Title */}
          <Typography
            variant='h6'
            className='font-bold'>
            {item?.title || "Product Name"}
          </Typography>

          {/* Addons */}
          {extraDisplay?.extras?.length > 0 && (
            <Box>
              <Typography
                variant='subtitle2'
                className='font-semibold mb-1'>
                {t("admin:addonHeader")}
              </Typography>
              <ul className='list-disc list-inside'>
                {extraDisplay.extras.map((addon, i) => (
                  <li
                    key={i}
                    className='text-sm'>
                    {addon.item} – {addon.price} kr.
                  </li>
                ))}
              </ul>
            </Box>
          )}

          {/* Price */}
          <Box>
            <Typography
              variant='subtitle2'
              className='font-semibold'>
              {t("admin:pricePer")}
            </Typography>
            <Typography className='text-cromboOrange font-bold text-lg'>
              {item?.price} kr.
            </Typography>
          </Box>
        </Box>

        {/* Quality Toggle */}
        <div className='flex items-center justify-center text-base font-semibold mt-2 p-4 bg-white drop-shadow-lg'>
          <h2 className='mr-4 text-center'>{t("admin:quality")}</h2>
          <MuiSwitch
            onColor={"#E16A2E"}
            checked={isQualityVerified}
            onChange={(e) => onQualityChange(e.target.checked)}
          />
        </div>
      </Paper>
      {/* Checkbox to show summary */}
      <FormControlLabel
        control={
          <Checkbox
            checked={showSummary}
            onChange={(e) => setShowSummary(e.target.checked)}
            color='primary'
          />
        }
        label={t("admin:advancedCalculations")}
        className='ml-2'
      />
      {/* Conditionally render summary table */}
      {showSummary && (
        <Box className='mt-4'>
          <SummaryTable
            item={item}
            itemCounter={itemCounter}
            priceArray={priceArray}
            showAdvanced={showAdvanced}
            productTotal={productTotal}
            productPriceAverage={productPriceAverage}
            productDiscountAverage={productDiscountAverage}
            totalDisplayForCount={totalDisplayForCount}
            extraDisplay={extraDisplay}
            extraItemTotal={extraItemTotal}
            extraPriceAverage={extraPriceAverage}
            extraDiscountAverage={extraDiscountAverage}
            delivery={delivery}
            bonusDiscountFunc={bonusDiscountFunc}
            grandTotal={grandTotal}
            t={t}
          />
        </Box>
      )}
    </>
  );
};

export default ProductPreviewCard;
